import { Link } from 'react-router-dom';
import { categories } from '@/mocks/tvShows';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <span className="text-background-50 font-bold text-lg leading-none">天</span>
                </div>
                <span className="text-xl font-bold text-foreground-900 font-heading">天堂影视</span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                天堂影视致力于为用户提供高清流畅的追剧体验，海量电视剧全集免费在线观看，每日更新，追剧党必备平台。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">热门分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">联系我们</h4>
              <ul className="space-y-2">
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-mail-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>contact@tiantangyingshi.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-customer-service-2-line text-primary-500 w-4 h-4 flex items-center justify-center"></i>
                  <span>在线客服：7×24小时</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                &copy; 2024 天堂影视 tiantangyingshi.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">用户协议</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}